export default "__VITE_ASSET__CP28CwHK__"